import OptionListCheckbox from './OptionListCheckbox.view';

export default OptionListCheckbox;
